const options: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
}

const DATE_FIELDS: (keyof Intl.DateTimeFormatOptions)[] = [
  'weekday',
  'year',
  'month',
  'day',
  'era',
  'dateStyle',
]

const formatterCache = new Map<string, Intl.DateTimeFormat>()

const getFormatter = (
  locale: string,
  option: Intl.DateTimeFormatOptions,
): Intl.DateTimeFormat | null => {
  const hasAnyField = Object.values(option).some(value => value !== undefined)
  const hasDateField = DATE_FIELDS.some(field => option[field] !== undefined)
  if (hasAnyField && !hasDateField) return null

  const key = `${locale}|${JSON.stringify(option)}`
  let formatter = formatterCache.get(key)
  if (!formatter) {
    formatter = new Intl.DateTimeFormat(locale, option)
    formatterCache.set(key, formatter)
  }
  return formatter
}

const toLocale = (lang: string) => (lang.substr(0, 2) === 'en' ? 'en-GB' : lang)

export const dateIso2localeString = (
  date: string | Date,
  lang: string,
  option = options,
): string => {
  const locale = toLocale(lang)
  const formattedDate = new Date(date)
  const formatter = getFormatter(locale, option)
  return formatter
    ? formatter.format(formattedDate)
    : formattedDate.toLocaleDateString(locale, option)
}

export const date2isoString = (date: Date, short?: boolean): string => {
  const isoString = date.toISOString()
  return short ? isoString.split('T')[0] : isoString
}

export const date2isoStringWithTimezone = (date: Date): string => {
  const timezoneOffset = new Date().getTimezoneOffset() * 60000
  return new Date(date.getTime() - timezoneOffset).toISOString()
}

export const date2localeString = (
  date: Date,
  lang: string,
  option = options,
): string => {
  const locale = toLocale(lang)
  const formatter = getFormatter(locale, option)
  return formatter
    ? formatter.format(date)
    : date.toLocaleDateString(locale, option)
}
